import { ask } from '@monorepo/tools/src/lib/tools/ask/ask';
import endpoints from './endpoints/index.endpoints';
import { queryParamsToSearchParams } from '@monorepo/tools/src/lib/utils/url';
import { IRequestOptions } from '@monorepo/tools/src/lib/interfaces/url';
import { id } from '@monorepo/tools/src/lib/types/primitives';

export interface NotificationMessage {
	id: number;
	date: string;
	msg: string;
	read?: boolean;
}

export const NotificationsApi = {
	list: async (accountId?: id | null, options?: IRequestOptions): Promise<NotificationMessage[]> => {
		const res = await ask.get(endpoints.notifications.list(accountId), queryParamsToSearchParams({ ...(options?.queryParams || {}) }));
		return res?.payload?.list ?? [];
	},
	markAsRead: async (id: number, accountId?: id | null): Promise<{ marked: boolean }> => {
		const res = await ask.get(endpoints.notifications.markAsRead(id, accountId));
		return res?.payload ?? { marked: false };
	},
	markAllAsRead: async (accountId?: id | null): Promise<{ marked: number }> => {
		const res = await ask.get(endpoints.notifications.markAllAsRead(accountId));
		return res?.payload ?? { marked: 0 };
	},
};
